import React from 'react';
import { FieldArray } from 'formik';

import { Button } from 'react-bootstrap';
import { CommonHash, SubLandingComponent } from 'app/types';

import SimpleCardForm from './SubComponentsForms/SimpleCardForm';
import StandardCardForm from './SubComponentsForms/StandardCardForm';
import SideImageCardForm from './SubComponentsForms/SideImageCardForm';
import OnlyImageCardForm from './SubComponentsForms/OnlyImageCardForm';
import JustTextCardForm from './SubComponentsForms/JustTextCardForm';
import FaqForm from './SubComponentsForms/FaqForm';
import WebinarForm from './SubComponentsForms/WebinarForm';
import TabForm from './SubComponentsForms/TabForm';
import TestimonialForm from './SubComponentsForms/TestimonialForm';

interface SubLandingComponentFormProps {
  name: string;
  landing_component: CommonHash;
  handleChange: {
    (e: React.ChangeEvent<any>): void;
    <T = string | React.ChangeEvent<any>>(field: T): T extends React.ChangeEvent<any>
      ? void
      : (e: string | React.ChangeEvent<any>) => void;
  };
  limit: number;
  sub_component: string;
  component_name: string;
}

const SubLandingComponentForm = ({
  name,
  landing_component,
  handleChange,
  limit,
  sub_component,
  component_name,
}: SubLandingComponentFormProps): React.ReactElement => {
  const buildSubComponentConfig = (sub_component: string) => {
    if (sub_component === 'simple') {
      return {
        icon_name: '',
        icon_style: 'on_top',
        card_title: '',
        card_text: '',
        card_background: 'transparent',
      };
    } else if (sub_component === 'standard') {
      return { card_title: '', card_text: '', card_background: 'transparent' };
    } else if (sub_component === 'side_image') {
      return { card_text: '', card_background: 'transparent', image_alignment: 'left' };
    } else if (sub_component === 'only_image') {
      return { card_background: 'transparent' };
    } else if (sub_component === 'faq') {
      return { question: '', answer: '' };
    } else if (sub_component === 'webinar') {
      return {
        webinar_title: '',
        webinar_date: '',
        webinar_timezone: '',
        webinar_description: '',
        webinar_link: '',
      };
    } else if (sub_component === 'tab') {
      return {
        tab_name: '',
        tab_type: 'subjects',
        tab_style: 'standard',
        button_style: 'primary',
      };
    } else if (sub_component === 'testimonial') {
      return {
        testimonial_title: '',
        content: '',
      };
    } else {
      return {};
    }
  };
  return (
    <FieldArray
      name={name}
      render={(arrayHelpers) => (
        <div>
          {landing_component.sub_landing_components &&
          landing_component.sub_landing_components.length ? (
            landing_component.sub_landing_components.map(
              (sub_landing_component: SubLandingComponent, index: number) => (
                <div key={index}>
                  {sub_component === 'simple' && (
                    <SimpleCardForm
                      landing_component={landing_component}
                      index={index}
                      name={name}
                      handleChange={handleChange}
                      arrayHelpers={arrayHelpers}
                      limit={limit}
                    />
                  )}
                  {sub_component === 'standard' && (
                    <StandardCardForm
                      landing_component={landing_component}
                      index={index}
                      name={name}
                      handleChange={handleChange}
                      arrayHelpers={arrayHelpers}
                      limit={limit}
                    />
                  )}
                  {sub_component === 'side_image' && (
                    <SideImageCardForm
                      landing_component={landing_component}
                      index={index}
                      name={name}
                      handleChange={handleChange}
                      arrayHelpers={arrayHelpers}
                      limit={limit}
                    />
                  )}
                  {sub_component === 'only_image' && (
                    <OnlyImageCardForm
                      landing_component={landing_component}
                      index={index}
                      name={name}
                      handleChange={handleChange}
                      arrayHelpers={arrayHelpers}
                      limit={limit}
                    />
                  )}
                  {sub_component === 'just_text' && (
                    <JustTextCardForm
                      landing_component={landing_component}
                      index={index}
                      name={name}
                      handleChange={handleChange}
                      arrayHelpers={arrayHelpers}
                      limit={limit}
                    />
                  )}
                  {sub_component === 'faq' && (
                    <FaqForm
                      landing_component={landing_component}
                      index={index}
                      name={name}
                      handleChange={handleChange}
                      arrayHelpers={arrayHelpers}
                      limit={limit}
                    />
                  )}
                  {sub_component === 'webinar' && (
                    <WebinarForm
                      landing_component={landing_component}
                      index={index}
                      name={name}
                      handleChange={handleChange}
                      arrayHelpers={arrayHelpers}
                      limit={limit}
                    />
                  )}
                  {sub_component === 'tab' && (
                    <TabForm
                      landing_component={landing_component}
                      index={index}
                      name={name}
                      handleChange={handleChange}
                      arrayHelpers={arrayHelpers}
                      limit={limit}
                    />
                  )}
                  {sub_component === 'testimonial' && (
                    <TestimonialForm
                      landing_component={landing_component}
                      index={index}
                      name={name}
                      handleChange={handleChange}
                      arrayHelpers={arrayHelpers}
                      limit={limit}
                    />
                  )}
                </div>
              )
            )
          ) : (
            <Button
              type="button"
              className="mt-3"
              variant="success"
              onClick={() =>
                arrayHelpers.push({
                  config: buildSubComponentConfig(sub_component),
                })
              }
            >
              {`Add a ${component_name}`}
            </Button>
          )}
        </div>
      )}
    />
  );
};

export default SubLandingComponentForm;
